import {Component, Input} from '@angular/core';
import { AccessItem } from '../../constants';

@Component({
  selector: 'profile-item',
  templateUrl: './access-item.component.html',
  styleUrls: ['./access-item.css']
})

export class AccessItemComponent {
  @Input() public title: string;
  @Input() public items: AccessItem;

  get keys(){
    return Object.keys(this.items);
  }
}



// WEBPACK FOOTER //
// ./src/app/access/components/access-item/access-item.component.ts